module.exports = __webpack_public_path__ + "static/media/avaneq-glitch-small.c240bb0d.png";